export class PropertyTax {
  assessedValueOfExistingStructure: number;
  taxesPaidOnExistingStructure: number;
  paidAdValoremTaxes?: boolean;

  constructor() {}
}
